<template>
  <!-- 电脑端视图 -->
  <template v-if="viewMode === 'pc'">
    <LoginPage v-if="!loggedIn" @success="onLoginSuccess" />
    <template v-else>
      <LogisticsList @logout="onLogout" />
      <button class="view-switch-btn" type="button" @click="viewMode = 'mobile'">移动端预览</button>
    </template>
  </template>
  <!-- 移动端视图 -->
  <template v-else>
    <MobileLoginPage v-if="!loggedIn" @success="onLoginSuccess" />
    <!-- 真机：全屏渲染，行为与原先完全一致 -->
    <MobileHome v-else-if="isMobileDevice" @logout="onLogout" />
    <!-- 电脑端预览：手机框容器，约束宽度并使 fixed 底栏相对容器定位 -->
    <div v-else class="mobile-preview">
      <MobileHome :pc-switchable="true" @logout="onLogout" @switch-pc="viewMode = 'pc'" />
    </div>
  </template>
</template>

<script>
import { ref, onMounted } from 'vue'
import LoginPage from './components/LoginPage.vue'
import LogisticsList from './components/LogisticsList.vue'
import MobileLoginPage from './components/MobileLoginPage.vue'
import MobileHome from './components/MobileHome.vue'

export default {
  name: 'App',
  components: {
    LoginPage,
    LogisticsList,
    MobileLoginPage,
    MobileHome
  },
  setup() {
    const loggedIn = ref(false)

    // 真实设备类型（userAgent 判定，仅初始化一次，不随窗口变化）
    const isMobileDevice = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    // 视图模式：pc=电脑端页面，mobile=移动端页面；默认跟随真实设备
    const viewMode = ref(isMobileDevice ? 'mobile' : 'pc')

    // 检查本地存储的 token
    const checkToken = () => {
      const token = localStorage.getItem('token')
      const expireAt = localStorage.getItem('expireAt')

      if (token && expireAt) {
        const expireDate = new Date(expireAt)
        if (expireDate > new Date()) {
          loggedIn.value = true
          return
        }
      }

      // token 过期或不存在，清除
      localStorage.removeItem('token')
      localStorage.removeItem('userName')
      localStorage.removeItem('expireAt')
      localStorage.removeItem('isAdmin')
      loggedIn.value = false
    }

    const onLoginSuccess = () => {
      loggedIn.value = true
    }

    const onLogout = () => {
      localStorage.removeItem('token')
      localStorage.removeItem('userName')
      localStorage.removeItem('expireAt')
      localStorage.removeItem('isAdmin')
      loggedIn.value = false
    }

    onMounted(() => {
      checkToken()
    })

    return {
      loggedIn,
      isMobileDevice,
      viewMode,
      onLoginSuccess,
      onLogout
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* PC 端样式 */
.pc-view {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f9fc 0%, #f2f5fb 100%);
}

/* 移动端样式 */
.mobile-view {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  /* 去掉移动端点击时的灰色高亮方框 */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

.view-switch-btn {
  position: fixed;
  top: 12px;
  right: 16px;
  z-index: 2000;
  padding: 6px 14px;
  border: none;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}

.view-switch-btn:hover {
  background: rgba(0, 0, 0, 0.75);
}

/* 电脑端移动视图的手机框：transform 使 MobileHome 内 position:fixed 的底栏相对本容器定位 */
.mobile-preview {
  width: 420px;
  max-width: 100%;
  height: 100vh;
  height: 100dvh;
  margin: 0 auto;
  transform: translateZ(0);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
</style>
